import Contact from "../../Pages/Contact";
import Dashboard from "../../Pages/Dashboard";
import Faq from "../../Pages/Faq";
import Home from "../../Pages/Home";
import Login from "../../Pages/Login";
import ProductItem from "../../Pages/ProductItem";
import Products from "../../Pages/Products";
import Profile from "../../Pages/DashboardPages/Profile";
import Reviews from "../../Pages/Reviews";
import NotFound from "./../../Pages/NotFound";
import PublicRoute from "../../Components/PrivateRoutes/PublicRoute";
import Checkout from "../../Pages/Checkout";
import UserRoute from "../../Components/PrivateRoutes/UserRoute";

export const routeDatas = [
  {
    title: "Home",
    route: "/",
    icon: "fa fa-home",
    visibility: true,
    isNavbarItem: true,
    child: (
      <Home
        title="Home : Gaming eSHop"
        description="Thanoseshop, One of the real online gaming currency & gift card selling organization. Well popular institution to sell gaming currency & gift cards with 100% safety and trust. 24/7 Open for all"
        keywords="Thanos eShop, UC shop, PUBG UC Shop, Free Fire UC Shop, GIft Card, Bangladeshi, Gaming shop, pubg uc store, pubg bd"
      />
    ),
  },
  {
    title: "Shop",
    route: "/products",
    icon: "fas fa-project-diagram ",
    visibility: true,
    isNavbarItem: false,
    keywords:
      "Thanos eShop, UC shop, PUBG UC Shop, Free Fire UC Shop, GIft Card, Bangladeshi, Gaming shop, pubg uc store, pubg bd, products, shop, eshop",
    child: (
      <Products
        title="Products list : Thanos Gaming eShop"
        description="A product list of Thanos eShop, from where you can buy and sell pubg UC"
        keywords="GamingCurrency,pubg,subscription,freefire"
      />
    ),
  },
  {
    title: "Shop",
    route: "/products/:pid",
    icon: "fas fa-project-diagram ",
    visibility: true,
    isNavbarItem: false,
    keywords: "",
    child: (
      <ProductItem
        title="A Product of Thanos eShop"
        description="A product of Thanos eShop, from where you can buy and sell pubg UC"
        keywords="pubg,netflix,hotstar,freefire"
      />
    ),
  },
  {
    title: "Checkout Page",
    route: "/products/:pid/checkout/:priceIdx",
    icon: "",
    visibility: true,
    isNavbarItem: false,
    keywords: "product,checkout",
    child: (
      <Checkout
        title="Checkout : Thanos Gaming eShop"
        description="Check out section of Thanos eShop, use your mobile banking or payment banking to do the shopping"
        keywords="product,checkout"
      />
    ),
  },
  {
    title: "Dashboard",
    route: "/dashboard",
    icon: "fa fa-gear",
    visibility: true,
    isNavbarItem: false,
    child: (
      // <UserRoute>
        <Dashboard
          title="Dashboard : Thanos Gaming eShop"
          description="A product of Thanos eShop, from where you can buy and sell pubg UC"
          keywords=""
        />
      // </UserRoute>
    ),
  },
  {
    title: "Reviews",
    route: "/reviews",
    icon: "fa fa-star-half",
    visibility: true,
    isNavbarItem: true,
    child: (
      <Reviews
        title="Reviews : Thanos Gaming eShop"
        description="All the Reviews of Thanos Gaming eShop is Here. You can  purchase item item and give us feedback about our service"
        keywords="site,review,star,feedback"
      />
    ),
  },
  {
    title: "FAQ",
    route: "/faq",
    icon: "fas fa-bolt",
    visibility: true,
    isNavbarItem: true,
    child: (
      <Faq
        title="FAQ : Thanos Gaming eShop"
        description="Frequently Asked Question about the Site or service"
        keywords="faq,thanosgaming,thanosgamingfaqpage"
      />
    ),
  },
  {
    title: "Login",
    route: "/login",
    icon: "fa fa-sign-in",
    visibility: true,
    isNavbarItem: false,
    child: (
      <PublicRoute>
        <Login
          title="Login : Thanos Gaming eShop"
          description="Login page for authentication of the user, make sure to provide the correct information"
          keywords="login,thanosgaming,thanosgamingloginpage"
        />
      </PublicRoute>
    ),
  },
  {
    title: "Not Found",
    route: "/*",
    icon: "fa fa-sign-in",
    visibility: true,
    isNavbarItem: false,
    child: (
      <NotFound
        title="Page Not Found : Thanos Gaming eShop"
        description="404 Error, page not found. Go back to home, or provide more valid routes to visit page"
        keywords="pagenotfound,404"
      />
    ),
  },
];
